
import {
    Card,
    CardContent,
    Grid,
    Container,
    Dialog,
    DialogTitle,
    Divider,
} from '@mui/material'
import { Formik } from 'formik'
import React from 'react'
import { ActionButton } from '../ui_utils'

const ExportDialog = ({
    title,
    initialValue,
    visible,
    onClose,
    exportMsg,
    exportIcon,
    okButtonStatus,
    okSubmit
}) => {


    if (initialValue == undefined)
        initialValue = {
            name: '',
        }

    const handleSubmit = async (value, { resetForm, setErrors, setStatus, setSubmitting }) => {
        okSubmit()
        onClose()
    }

    return (
        <div>
            <Dialog maxWidth={'sm'} fullWidth anchor="right" backdrop="static" variant="temporary" open={visible}>
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Formik
                        onSubmit={handleSubmit}
                        initialValues={initialValue}
                    >
                        {({
                            handleSubmit,
                        }) => (

                            <form onSubmit={handleSubmit}>
                                <Divider my={2} />
                                <Card >
                                    <CardContent>
                                        <Grid container spacing={5} style={{ paddingTop: 10, paddingLeft: 10 }}>
                                            <Grid item>
                                                <Grid container ><Grid item sx={{ marginRight: 10 }} ><p>{exportMsg} </p></Grid><Grid item ><p>{exportIcon}</p></Grid></Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent="flex-end">
                                            <Grid item>
                                                <ActionButton variant="outlined" size='medium' type="submit" mt={8} disabled={okButtonStatus} >
                                                    Ok
                                                </ActionButton>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </div>
    )
}

export default ExportDialog